import * as React from 'react';
import { ErrorWrapper } from '../ErrorWrapper';
import { DENIED_BY_SANCTIONS_LINK } from './constants';
import { forbiddenIcon } from '../../icons';
import { Link } from '../../../../../../../common/Link';
import { generateErrorBannerShowAction } from '../../../../../../../../actions/webview';
import { AppContext } from '../../../../../../../../../AppModulesWrapper';

export const DeniedBySanctions = () => {
  const { webview } = React.useContext(AppContext);

  React.useEffect(() => {
    webview.sendAction(generateErrorBannerShowAction('denied-by-sanctions-unavailable-reason-banner-show'));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ErrorWrapper icon={forbiddenIcon}>
      Вы не можете продвигать объявление в поиске из-за ограничений от модерации.{' '}
      <Link href={DENIED_BY_SANCTIONS_LINK} target="_blank" rel="noreferrer">
        Подробнее
      </Link>
    </ErrorWrapper>
  );
};
